import React from 'react';

export interface ProviderContext {
  networkAvailable: boolean;
}

// @ts-ignore
export default React.createContext<ProviderContext>();